<app-dialog-header [title]="'GENERAL.BUTTON.CONFIRM'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <p class="my-0">
        <span>{{ 'PERFORMANCE_REVIEW.MESSAGE.DELETE_DESCRIPTION_PART_1' | translate: { performanceReviewName: performanceTeamReview.name } }}</span>
        <br />
        <br />
        <span>{{ 'PERFORMANCE_REVIEW.MESSAGE.DELETE_DESCRIPTION_PART_2' | translate }}</span>
        <br />
        <br />
        <span>{{ 'PERFORMANCE_REVIEW.MESSAGE.DELETE_DESCRIPTION_PART_3' | translate }}</span>
    </p>
    <form [formGroup]="formGroup" class="mt-16">
        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-label>
            <input matInput name="name" formControlName="name" />
        </mat-form-field>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.DELETE'" color="warn" [disabled]="!formGroup.valid" (onClick)="deletePerformanceTeamReview()"></app-flat-button>
</div>
